import { FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { CONFIRM_PASSWORD, CURRENT_PASSWORD, NEW_PASSWORD } from "./consts";
import useLogin from "./useChangePassword";

const ChangePassword = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    onEyeIconClick,
    isPassword,
    Icon,
    isChangePasswordPending,
  } = useLogin();
  const { errors } = form.formState;

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Card className="w-full mt-0 pt-0 shadow-none border-none">
          <CardHeader className="my-[20px]">
            <CardTitle className="text-center font-[500] text-[24px]">
              Change Password
            </CardTitle>
            <span className="text-[14px] text-g-400 text-center">
              Please enter details
            </span>
          </CardHeader>
          <CardContent>
            <div className="grid grid-col-1 gap-5">
              <div>
                <label className="text-[14px] font-[400]">Old Password</label>
                <FormInput
                  name={CURRENT_PASSWORD}
                  control={form.control}
                  placeholder="Please enter"
                  error={errors[CURRENT_PASSWORD]?.message}
                  isRequired={requiredFields.includes(CURRENT_PASSWORD)}
                  type={isPassword["current"] ? "password" : "text"}
                  endIcon={
                    <Icon
                      className="h-4 w-4"
                      onClick={onEyeIconClick("current")}
                    />
                  }
                />
              </div>
              <div>
                <label className="text-[14px] font-[400]">New Password</label>
                <FormInput
                  name={NEW_PASSWORD}
                  control={form.control}
                  placeholder="Please enter"
                  error={errors[NEW_PASSWORD]?.message}
                  isRequired={requiredFields.includes(NEW_PASSWORD)}
                  type={isPassword["newPassword"] ? "password" : "text"}
                  endIcon={
                    <Icon
                      className="h-4 w-4"
                      onClick={onEyeIconClick("newPassword")}
                    />
                  }
                />
              </div>
              <div>
                <label className="text-[14px] font-[400]">
                  Confirm Password
                </label>
                <FormInput
                  name={CONFIRM_PASSWORD}
                  control={form.control}
                  placeholder="Please enter"
                  error={errors[CONFIRM_PASSWORD]?.message}
                  isRequired={requiredFields.includes(CONFIRM_PASSWORD)}
                  type={isPassword["confirm"] ? "password" : "text"}
                  endIcon={
                    <Icon
                      className="h-4 w-4"
                      onClick={onEyeIconClick("confirm")}
                    />
                  }
                />
              </div>
            </div>
          </CardContent>
          <CardFooter>
            <Button
              type="submit"
              className="w-full"
              disabled={isChangePasswordPending}
            >
              {isChangePasswordPending ? <Loader variant="secondary" /> : ""}{" "}
              Change Password
            </Button>
          </CardFooter>
        </Card>
      </form>
    </FormProvider>
  );
};

export default ChangePassword;
